/* eslint-disable */ import { detailComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const bottomCabinetWithoutApplianceComponents = [
    attachComponent.withComponent(detailComponent, 'default', true).withAlias('BottomCabinetWithoutAppliance').attach(memoEval((self)=>[
            self.$name,
            self.$sku,
            self.$description,
            self.$thumbnailUrl
        ], ($name, $sku, $description, $thumbnailUrl)=>({
            title: $name,
            subtitle: $sku,
            description: $description,
            thumbnailUrl: $thumbnailUrl
        })))
];

//# sourceMappingURL=bottom-cabinet-without-appliance.js.map